export default "__VITE_ASSET__Aie9AyxS__"